import { AUDIO_CONTEXT_OPTIONS, AUDIO_PROCESSOR_MODULE_URL } from '../constants';

/**
 * 音声取り込み用の AudioContext を生成し、AudioWorklet を読み込む
 *
 * サンプリングレートの指定は 2 通りの失敗の仕方がある。
 *  - 例外を投げる       -> ここで null を返し、呼び出し側がエラー状態にする
 *  - 黙って無視される   -> worklet 側が実レートから 16kHz へ落とす(多層防御)
 *
 * 後者は放置すると「なぜか認識精度が悪い」としか見えず、Issue #1835 が
 * 長く生き延びた原因でもあるため、検知したら警告を残す。
 *
 * @returns 生成した AudioContext。生成に失敗した場合は null
 */
export const createAudioContext = async (): Promise<AudioContext | null> => {
  let audioContext: AudioContext;
  try {
    audioContext = new AudioContext(AUDIO_CONTEXT_OPTIONS);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('AudioContextの生成に失敗しました', e);

    return null;
  }

  if (audioContext.sampleRate !== AUDIO_CONTEXT_OPTIONS.sampleRate) {
    // eslint-disable-next-line no-console
    console.warn(
      `AudioContextのサンプリングレート指定が無視されました(要求: ${AUDIO_CONTEXT_OPTIONS.sampleRate}Hz / 実際: ${audioContext.sampleRate}Hz)。worklet側でリサンプルします`,
    );
  }

  try {
    await audioContext.audioWorklet.addModule(AUDIO_PROCESSOR_MODULE_URL);
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('AudioWorkletの読み込みに失敗しました', e);
    // close 自体の失敗はここでは何もできないので握りつぶす
    // (await しないと未処理の Promise 拒否になる)
    await audioContext.close().catch(() => undefined);

    return null;
  }

  return audioContext;
};
